<template>
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_2125_27748)">
            <path
                d="M23.6526 8.03342L13.0514 4.23844C12.537 4.05431 11.9746 4.05431 11.4603 4.23844L0.888252 8.03342C0.527802 8.16467 0.286377 8.50967 0.286377 8.89967C0.286377 9.28967 0.527802 9.63654 0.888252 9.76554L3.139 10.5722C2.69313 11.1647 2.37925 11.8532 2.21838 12.5953C1.78825 12.7772 1.48638 13.2047 1.48638 13.6996C1.48638 14.0729 1.6669 14.393 1.93413 14.6131L1.003 20.2006C0.941877 20.5659 1.22388 20.8996 1.59475 20.8996H3.778C4.14876 20.8996 4.43088 20.5667 4.36975 20.201L3.43863 14.6135C3.706 14.3934 3.88638 14.0409 3.88638 13.6996C3.88638 13.3138 3.69235 12.986 3.40938 12.7663C3.5665 12.1086 3.88834 11.5017 4.34463 11.0027L11.4921 13.5613C12.0065 13.7454 12.5689 13.7454 13.0833 13.5613L23.6845 9.76629C24.0464 9.63467 24.2864 9.28967 24.2864 8.89967C24.2864 8.50967 24.0464 8.16467 23.6526 8.03342ZM13.4526 14.6896C13.1001 14.8284 12.6951 14.8996 12.2864 14.8996C11.8774 14.8998 11.4714 14.8293 11.0864 14.6913L5.64138 12.7434L5.08638 18.0984C5.08638 19.6471 8.27763 20.8996 12.2864 20.8996C16.2276 20.8996 19.4864 19.6471 19.4864 18.0995L18.9321 12.7408L13.4526 14.6896Z"
                fill="#0FA2B7"
            />
        </g>
        <defs>
            <clipPath id="clip0_2125_27748">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0 0.5)"
                />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
